import {
  ManagedLeadDropRequest,
  ManagedLeadUpdateContract,
} from '../../services/api/managed-leads/managedLeads';

/**
 * Whether an update can actually be saved from where the lead stands. A lead
 * awaiting Drop review is read-only, a stage the policy froze accepts no
 * advancement, and a contract offering no transition has nothing to submit:
 * each of the three turns the form into a dead end, so nothing on the page may
 * lead the operator into it.
 *
 * `pendingDrop` is a parameter rather than `detail.pendingDrop` because the
 * update form knows about a request the re-read detail has not caught up with
 * yet, while a box elsewhere on the page only has the detail to go on.
 */
export const canUpdateManagedLead = (
  detail: ManagedLeadUpdateContract,
  pendingDrop: ManagedLeadDropRequest | null
) => !pendingDrop && detail.updatable && detail.transitions.length > 0;
